





























import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import gtChooseMedia from "./chooseMedia.vue";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: { gtChooseMedia }
})
export default class skuMediaDialog extends Vue {
  visible = false;
  @Prop({ default: "spu" }) mediaTab;
  @Prop({ default: {} }) mediaData;
  mediaTempData: any = {};
  mediaTemp(data) {
    this.mediaTempData = data;
  }
  mediaSubmit() {
    this.$emit("changeSkuMedia", this.mediaTempData);
    this.visible = false;
  }
}
